import * as Api from '../../../api/Api';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import AgTable from '../../../Components/Table/AgTable';

export default function EvolucionVentasTotales({ unidadEconomicaId, mesCierre, anio }) {

    let headers = [
        {
            headerName: 'CeBe',
            field: 'centroBeneficio',
        }
    ];
    for (let i = 1; i <= 12; i++) {
        headers.push({
            headerName: Utilities.getHeaderMonth(mesCierre, anio, i),
            field: 'mes' + (i),
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data[`mes${i}`], true)}</>
            )
        });
    }

    return (
        <AgTable
            idContent={"EvolucionVentasTotales " + unidadEconomicaId + mesCierre + anio}
            apiService={Api.EvolucionVentasTotales}
            setAuxData={null}
            header={headers}
            titleExcel={"EvolucionVentasTotales - " + unidadEconomicaId + "/" + mesCierre + " " + anio}
            conditions={true}
            args={{
                unidadEconomicaId: unidadEconomicaId,
                mesCorte: mesCierre,
                anio: (anio + 1),
                token: useGetToken()
            }}
            hideFilter={false}
            paginationPageSize={8}
            rowHeight={40}
            useFlex={false}
        />
    )
}